import React from 'react'

function Breadcrumb() {
    return (
        <div className='breadcrumb'>
            <h1 className='bradcrumb-title'>About Us</h1>
        </div>
    )
}

export default Breadcrumb